import { makePaymentModalElem } from './constants'
import { paymentModalLoadingShow } from '../loading'
import paymentModalTitle from './title'
import { paymentModalFooterBackAttach, paymentModalFooterContinueAttach, paymentModalFooterPayAttach } from './footer'

export default function paymentModalOpen () {
  buildPaymentModal()
  makePaymentModalElem.modal('show')
}

function buildPaymentModal () {
  paymentModalTitle()
  paymentModalLoadingShow()
  paymentModalFooterBackAttach()
  paymentModalFooterContinueAttach()
  paymentModalFooterPayAttach()
}
